import { LoginAnalyticsGaService } from '@analytics/feature';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AuthService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { AuthMethods } from '@user/const';
import { BehaviorSubject, from, Observable, tap, withLatestFrom } from 'rxjs';

@Injectable()
export class LoginFormComponentService {
  private currentAuthMethod$ = new BehaviorSubject<AuthMethods>(AuthMethods.ByCode);
  private phoneControl = new FormControl('', [
    Validators.minLength(10),
    Validators.required,
    Validators.pattern(/^[3489]\d{9}$/),
  ]);

  constructor(
    private authService: AuthService,
    private globalMessage: GlobalMessageService,
    private loginAnalyticsService: LoginAnalyticsGaService,
  ) {}

  login(phone: string, password: string, usePasswordFromSms: boolean): void {
    const userName = '7' + phone + '&' + usePasswordFromSms;

    from(this.authService.loginWithCredentials(userName, password))
      .pipe(
        withLatestFrom(this.authService.isUserLoggedIn(), this.currentAuthMethod$),
        tap(([, isLoggedIn, currentAuthMethod]: [void, boolean, AuthMethods]) => {
          if (isLoggedIn) {
            switch (currentAuthMethod) {
              case AuthMethods.ByPassword:
                this.loginAnalyticsService.sendGa('loginPass');
                break;
              case AuthMethods.ByCode:
                this.loginAnalyticsService.sendGa('loginSMS');
                break;
            }

            this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
          }
        }),
      )
      .subscribe();
  }

  getCurrentAuthMethod(): Observable<AuthMethods> {
    return this.currentAuthMethod$.asObservable();
  }

  getPhoneControl(): FormControl {
    return this.phoneControl;
  }

  setCurrentAuthMethod(method: AuthMethods): void {
    this.currentAuthMethod$.next(method);
  }
}
